var _defs, _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _path, _path2, _path3, _path4, _path5, _path6, _text, _text2, _text3, _rect4, _rect5, _line5, _line6, _line7, _line8, _path7, _path8, _path9, _path10, _path11, _text4, _text5, _text6, _rect6, _rect7, _line9, _line10, _path12, _path13, _path14, _path15, _text7, _rect8, _rect9, _line11, _line12, _line13, _line14, _line15, _path16, _path17, _path18, _path19, _text8, _text9, _text10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChartKrPcModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 420 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kr-bg",
    cx: "50%",
    cy: "40%",
    r: "60%",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDF0EF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "kr-grid",
    x: 0,
    y: 0,
    width: 12,
    height: 12,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 0.55,
    fill: "#C7D1CC",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr-oil-fill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f87171",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f87171",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr-water-fill",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60a5fa",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#60a5fa",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kr-gas-fill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fb923c",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fb923c",
    stopOpacity: 0.02
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 200,
    rx: 14,
    fill: "url(#kr-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 128,
    height: 120,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 104,
    height: 94,
    fill: "url(#kr-grid)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 112,
    x2: 128,
    y2: 112,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 18,
    x2: 24,
    y2: 112,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 50,
    x2: 128,
    y2: 50,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 80,
    x2: 128,
    y2: 80,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,20 C38,22 52,30 64,55 C76,80 90,105 128,112",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20 C40,24 55,38 68,65 C80,88 95,108 128,112",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20 C42,26 58,44 72,72 C84,96 98,110 128,112",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "1.5 2",
    strokeOpacity: 0.45
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,112 C62,112 78,105 90,82 C102,58 112,32 128,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24,112 C65,112 82,106 94,84 C106,62 116,34 128,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24,112 C68,112 84,107 96,86 C108,65 118,36 128,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "1.5 2",
    strokeOpacity: 0.45
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 126,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "Sw")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 65,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,14,65)"
  }, "Kr")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 134,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Oil-Water System")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 8,
    width: 128,
    height: 120,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 18,
    width: 104,
    height: 94,
    fill: "url(#kr-grid)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 112,
    x2: 268,
    y2: 112,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 18,
    x2: 164,
    y2: 112,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 50,
    x2: 268,
    y2: 50,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 80,
    x2: 268,
    y2: 80,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164,20 C172,21 184,26 196,48 C210,74 224,104 268,112",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164,20 C174,22 186,30 200,55 C214,80 228,106 268,112",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164,20 C176,24 190,34 204,62 C218,86 232,108 268,112",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "1.5 2",
    strokeOpacity: 0.45
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164,112 C208,112 220,104 232,82 C244,58 254,30 268,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164,112 C210,112 222,106 234,84 C246,62 256,33 268,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.6
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 126,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "Sw")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 65,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,154,65)"
  }, "Kr")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 134,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Oil-Water (BC)")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 144,
    width: 128,
    height: 48,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 150,
    width: 104,
    height: 34,
    fill: "url(#kr-grid)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 184,
    x2: 128,
    y2: 184,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 150,
    x2: 24,
    y2: 184,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24,184 C50,184 62,176 74,162 C86,148 98,150 128,150",
    stroke: "#fb923c",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24,184 C52,184 64,177 76,164 C88,150 100,151 128,151",
    stroke: "#fb923c",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24,150 C54,150 68,158 80,172 C92,184 104,184 128,184",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24,151 C56,151 70,160 82,174 C94,184 106,184 128,184",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.6
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 196,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Gas-Oil System")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 8,
    width: 124,
    height: 184,
    rx: 7,
    fill: "white",
    fillOpacity: 0.7,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 18,
    width: 92,
    height: 136,
    fill: "url(#kr-grid)"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 304,
    y1: 154,
    x2: 396,
    y2: 154,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 304,
    y1: 18,
    x2: 304,
    y2: 154,
    stroke: "#A7B7AF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 304,
    y1: 56,
    x2: 396,
    y2: 56,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 304,
    y1: 96,
    x2: 396,
    y2: 96,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 304,
    y1: 126,
    x2: 396,
    y2: 126,
    stroke: "#E0E6E3",
    strokeWidth: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M304,20 C318,22 330,34 344,60 C356,84 370,140 396,154",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M304,154 C330,154 344,142 356,118 C368,92 380,40 396,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M304,20 C316,21 326,28 338,50 C350,74 364,136 396,154",
    stroke: "#f87171",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.55
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M304,154 C332,154 346,144 358,120 C370,94 382,42 396,20",
    stroke: "#60a5fa",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    fill: "none",
    strokeDasharray: "3 2",
    strokeOpacity: 0.55
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 168,
    textAnchor: "middle",
    fontSize: 7,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF"
  }, "Sw")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 293,
    y: 86,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90,293,86)"
  }, "Kr")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 178,
    textAnchor: "middle",
    fontSize: 6.5,
    fontFamily: "system-ui,sans-serif",
    fill: "#A7B7AF",
    fontWeight: 500
  }, "Oil-Water (BC)")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartKrPcModel);
export default __webpack_public_path__ + "static/media/empty-chart-kr-pc-model.bfb6b0bcce0e3be36c674d277fd8a88c.svg";
export { ForwardRef as ReactComponent };